import { render, staticRenderFns } from "./FormBlockRenderer.vue?vue&type=template&id=5f645d4f"
import script from "./FormBlockRenderer.vue?vue&type=script&lang=ts"
export * from "./FormBlockRenderer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports